var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldHashtagDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.73 11.832.19-1.66h-1.65l-.19 1.66h1.65z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.79 2.03c-.2-.02-.4-.03-.6-.03H7.81c-.2 0-.4.01-.6.03-3.08.2-4.98 2.1-5.18 5.18-.02.2-.03.4-.03.6v8.38c0 .2.01.4.03.6.2 3.08 2.1 4.98 5.18 5.18.2.02.4.03.6.03h5.69c.55 0 1-.45 1-1v-2.97a3.53 3.53 0 0 1 3.53-3.53H21c.55 0 1-.45 1-1V7.81c0-.2-.01-.4-.03-.6-.2-3.08-2.1-4.98-5.18-5.18zm-3.36 8.14-.19 1.66h2.23a.749.749 0 1 1 0 1.5h-2.39l-.28 2.49c-.04.38-.37.67-.75.67-.02 0-.05 0-.08-.01a.74.74 0 0 1-.66-.83l.26-2.32H9.92l-.28 2.49c-.04.38-.37.67-.74.67-.03 0-.06 0-.09-.01a.74.74 0 0 1-.66-.83l.26-2.32H6c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.57l.19-1.66H6.53a.749.749 0 1 1 0-1.5h2.39l.28-2.49c.05-.41.42-.71.83-.66.41.04.71.41.66.83l-.26 2.32h1.65l.28-2.49c.05-.41.42-.71.83-.66.41.04.71.41.66.83l-.26 2.32H16c.41 0 .75.34.75.75s-.34.75-.75.75h-2.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.03 23c-1.27 0-2.03-.76-2.03-2.03v-2.94c0-1.27.76-2.03 2.03-2.03h2.94c1.27 0 2.03.76 2.03 2.03v2.94c0 1.27-.76 2.03-2.03 2.03h-2.94zm2.72-3.49a.62.62 0 0 0-.44.18l-.18.18v-2.24c0-.35-.28-.63-.63-.63s-.63.28-.63.63v2.24l-.18-.18a.628.628 0 0 0-.88 0c-.24.24-.24.64 0 .88l1.25 1.25c.05.05.12.09.19.12.02.01.04.01.06.02.05.02.1.03.16.03h.06c.07 0 .13-.01.2-.04h.02c.07-.03.13-.07.18-.12.01-.01.01-.01.02-.01l1.25-1.25c.24-.24.24-.64-.01-.88a.62.62 0 0 0-.44-.18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldHashtagDown);
export default __webpack_public_path__ + "static/media/vuesax-bold-hashtag-down.aa5e11bbbdd619986340741d87a127c1.svg";
export { ForwardRef as ReactComponent };